import styled from "styled-components";
import { Flex, Table } from "src/components/ui";
import { useNavigate } from "react-router-dom";
import { Dispatch, FC, SetStateAction, useEffect, useState } from "react";
import { usePagination } from "src/hooks";
import { PaginationProps } from "../ui/Pagination";
import img from "../../assets/images/common/profileIcon.svg";
import AdsTableActionBtn from "./adsTableActionBtn";
import { formatDate, formatTime } from "src/utils";

const AdsTableContainer = styled.div`
	background-color: ${(props) => props.theme.colors.white};
	border-radius: 16px;
	padding: 20px 0;
	.heading {
		color: ${(props) => props.theme.colors.text_01};
		padding: 0 20px;

		.title {
			font-weight: 600;
			font-size: 22px;
			line-height: 32px;
		}
		.info {
			font-weight: 500;
			font-size: 14px;
			line-height: 24px;
		}
	}
`;

export const AdsTable: FC<{
	rows: any[];
	pgn: number;
	setpgn: Dispatch<SetStateAction<number>>;
	paginationData: PaginationProps;
	callback: () => void;
}> = ({ rows, pgn, setpgn, paginationData, callback }) => {
	const AdsTableHeaders = [
		{
			title: "Advert Name",
			render: (row: IAdvertisement) => (
				<Flex gap='10px' align='center'>
					<img
						style={{ width: 40, height: 40, borderRadius: "50%" }}
						className='shadow'
						src={row.mediaUrl || img}
						alt=''
					/>{" "}
					{row.title}
				</Flex>
			),
		},
		{
			title: "Links",
			render: (row: IAdvertisement) => `${row.embedLink ? "Yes" : "No"}`,
		},
		{
			title: "Click count",
			render: (row: IAdvertisement) => `${row.clickedBy.length}`,
		},
		{
			title: "Impressions",
			render: (row: IAdvertisement) => `${row.impression[0]?.count || 0}`,
		},
		{
			title: "From",
			render: (row: IAdvertisement) => formatDate(`${row.startDate}`),
		},
		{
			title: "To",
			render: (row: IAdvertisement) => formatDate(`${row.endDate}`),
		},
		{
			title: "Type",
			render: (row: IAdvertisement) => (
				<span className='capitalize'>{row.subscriptionType}</span>
			),
		},
		{
			title: "Status",
			render: (row: IAdvertisement) => {
				const status = row.status;
				return (
					<div className='flex gap-4 justify-between items-center'>
						<h2
							className={`${
								status === "active"
									? "text-[#7607BD]"
									: status === "completed"
									? "text-[#00CCCD]"
									: status === "paused"
									? "text-[#4D4D4D]"
									: status === "cancelled"
									? "text-[#FF0000]"
									: "text-[#FFAD4A]"
							} capitalize`}
						>
							{status}
						</h2>
						<AdsTableActionBtn callback={callback} ad={row} />
					</div>
				);
			},
		},
	];

	const navigate = useNavigate();
	const handleNavigate = (row: any) => {};

	const { page, limit, Pagination } = usePagination(
		{
			page: pgn,
			limit: 10,
			total: rows.length,
			setPageNo: (newPage: number) => {
				setpgn(newPage);
			},
		},
		paginationData
	);

	const [paginatedRows, setPaginatedRows] = useState<IAdvertisement[]>([]);

	useEffect(() => {
		const currentPage = Math.max(1, pgn);
		const start = (currentPage - 1) * limit;
		const end = start + limit;
		console.log({ currentPage, start, end });

		if (rows.length === 1) {
			setPaginatedRows(rows);
		} else {
			setPaginatedRows(rows.slice(start, end));
		}
	}, [pgn, limit, rows]);

	return (
		<AdsTableContainer>
			{rows.length > 0 ? (
				<>
					<Table
						rows={rows}
						headers={AdsTableHeaders}
						showHead={true}
						onRowClick={handleNavigate}
					/>
					{rows.length > 0 && <Pagination />}
				</>
			) : (
				<h5 className='font-bold text-center py-8 italic text-2xl'>No Ads</h5>
			)}
		</AdsTableContainer>
	);
};

export default AdsTable;
